export default {
  styleOverrides: {
    root: {
      paddingTop: '24px !important',
    },
  },
}
